import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';
import AidexacxPageRouteView from './pages/AidexacxPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';
import AssistantSettingsIndex from './assistants/settings/Settings.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import CustomToolsIndex from './tools/Index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.AIDEXACX,
};

const metaV2 = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.AIDEXACX_V2,
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'aidexacx_assistants_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'aidexacx_assistants_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'aidexacx_tools_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'aidexacx_assistants_scenarios_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'aidexacx_assistants_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'aidexacx_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'aidexacx_assistants_responses_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'aidexacx_assistants_settings_index',
    meta,
  },
  // Settings sub-pages (guardrails and guidelines)
  {
    path: frontendURL(
      'accounts/:accountId/aidexacx/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'aidexacx_assistants_guardrails_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/aidexacx/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'aidexacx_assistants_guidelines_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'aidexacx_assistants_create_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/aidexacx/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'aidexacx_assistants_index',
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/aidexacx'),
    component: AidexacxPageRouteView,
    redirect: to => {
      return {
        name: 'aidexacx_assistants_index',
        params: {
          navigationPath: 'aidexacx_assistants_responses_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
